import type { PropsWithChildren, ReactNode } from 'react';

interface ScreenshotDialogProps {
    title: ReactNode;
    buttons: ReactNode;
}

const ScreenshotDialog = ({ title, buttons, children }: PropsWithChildren & ScreenshotDialogProps) => {
    return (
        <div className='pointer-events-none user-select-none bg-lighter' style={{ padding: 'initial' }}>
            <div className='modal show modal-enter-done position-relative'>
                <div className='modal-dialog modal-sm margin-15'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <div className='modal-header-text'>
                                <div className='modal-header-title'>{title}</div>
                            </div>
                            <div className='modal-header-buttons'>
                                <button type='button' className='btn btn-icon-only btn-muted modal-header-close close'>
                                    <span className='rioglyph rioglyph-remove' />
                                </button>
                            </div>
                        </div>
                        <div className='modal-body' style={{ padding: '20px' }}>
                            {/* override padding as this is used within a split-dialog which breaks the padding */}
                            {children}
                        </div>
                        <div className='modal-footer'>{buttons}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScreenshotDialog;
